export const QATC_HIGHLIGHT_FEATURE_NAME = 'floating-cart-quantity-highlight';

let claimed = false;

export const claimQatcHighlight = (): boolean => {
  if (claimed) {return false;}
  claimed = true;
  return true;
};

export const releaseQatcHighlight = (): void => {
  claimed = false;
};
